import {format, parseISO} from "date-fns";

const dateToString = (aDate) => {
  if (!aDate) return "...";
  const parsedDate = parseISO(aDate);
  return format(parsedDate, "dd MMM yyyy");
};

export default dateToString;
